module.exports = __webpack_public_path__ + "fonts/TriviaSerifMedium.c4c13819.otf";